import React from 'react';
import { Chip } from '@mui/material';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import theme from '../theme';
import { lighten } from '@mui/material/styles';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const StatusChip = ({ status }) => {
  if (status === 'Valid') {
    return (
      <Chip
        id="irbm-status-chip"
        label="Accepted"
        icon={<CheckCircleOutlinedIcon fontSize="small" color={theme.palette.success.main} />}
        size="small"
        sx={{ backgroundColor: lighten(theme.palette.success.main, 0.88), color: theme.palette.success.main }}
      />
    );
  }
  if (status === 'Submitted') {
    return (
      <Chip
        id="irbm-status-chip"
        label="Submitted"
        icon={<AccessTimeOutlinedIcon fontSize="small" color={theme.palette.info.main} />}
        size="small"
        sx={{ backgroundColor: lighten(theme.palette.info.main, 0.88), color: theme.palette.info.main }}
      />
    );
  }
  if (status === 'Invalid') {
    return (
      <Chip
        id="irbm-status-chip"
        label="Rejected"
        icon={<WarningAmberIcon fontSize="small" color={theme.palette.error.main} />}
        size="small"
        sx={{ backgroundColor: lighten(theme.palette.error.main, 0.88), color: theme.palette.error.main }}
      />
    );
  }
  if (status === 'Cancelled') {
    return (
      <Chip
        id="irbm-status-chip"
        label="Cancelled"
        icon={<HorizontalRuleIcon fontSize="small" color={theme.palette.grey[100]} />}
        size="small"
        sx={{ backgroundColor: lighten(theme.palette.grey[500], 0.88), color: theme.palette.grey[700] }}
      />
    );
  }
  if (!status) {
    return <Chip label="Not Submitted" icon={<InfoOutlinedIcon fontSize="small" />} size="small" variant="outlined" />;
  }

  return null;
};

export default StatusChip;
